import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full sm:p-4" }
const _hoisted_4 = { class: "mt-2 text-left sm:mt-5" }
const _hoisted_5 = { class: "flex justify-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "mt-2 pb-2 text-left" }
const _hoisted_8 = { class: "grid grid-cols-2 text-sm text-gray-500 my-4" }
const _hoisted_9 = { class: "pl-2" }
const _hoisted_10 = { class: "mt-1 w-full overflow-x-auto" }
const _hoisted_11 = { class: "p-1" }

import { computed, onMounted, ref, watchEffect } from "vue";
import dayjs from "dayjs";
import "dayjs/locale/th";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
} from "@headlessui/vue";
import DataTable from "../tools/DataTable.vue";
import { translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'GameResultDialog',
  props: { dataRows: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form"],
  setup(__props, { emit }) {

const props = __props

const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});

const columns = [
  {
    label: translate("messages.gameRounds.originalRoundBetId"),
    field: "originalBetId",
  },
  {
    label: translate("messages.gameRounds.betAmount"),
    field: "betAmount",
  },
  {
    label: translate("messages.gameRounds.winAmount"),
    field: "winAmount",
    class: (data: any) => {
      if (data.winAmount < 0) {
        return "text-red-500";
      }
      return "text-green-500";
    },
  },
  {
    label: translate("messages.gameRounds.winLoss"),
    field: "winLossAmount",
    class: (data: any) => {
      if (data.winLossAmount < 0) {
        return "text-red-500";
      }
      return "text-green-500";
    },
  },
  {
    label: translate("messages.gameRounds.createdAt"),
    field: "createAt",
    format: (data: any) => dayjs(data.createAt).locale("th").format("LLL"),
  },
  {
    label: translate("messages.gameRounds.updatedAt"),
    field: "updateAt",
    format: (data: any) => dayjs(data.updateAt).locale("th").format("LLL"),
  },
  {
    label: "",
    field: "url",
    format: (data: any) => {
      return "Link";
    },
    class: (data: any) => {
      return data.url ? "bg-blue-400 text-white cursor-pointer ": "invisible";
    },
    isFunction: true,
    function: (data: any) => {
      window.open(data.url);
    },
  },
];




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_Transition, {
                    "leave-active-class": "transition duration-100 ease-in",
                    "leave-from-class": "opacity-100",
                    "leave-to-class": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-lg leading-6 font-medium text-gray-900"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.gameRounds.gameResultDetails")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.gameRounds.originalRoundId")) + " : " + _toDisplayString(__props.dataRows?.originalRoundId), 1),
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.gameRounds.refCode2")) + " : " + _toDisplayString(__props.dataRows?.refCode2), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("messages.gameRounds.betAmount")) + " : " + _toDisplayString(__props.dataRows?.betAmount), 1),
                                _createElementVNode("p", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("messages.gameRounds.winAmount")) + ": ", 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(
                              __props.dataRows?.winAmount < 0
                                ? 'text-red-500'
                                : 'text-green-500'
                            )
                                  }, _toDisplayString(__props.dataRows?.winAmount), 3)
                                ]),
                                _createElementVNode("p", null, [
                                  _createTextVNode(_toDisplayString(_ctx.$t("messages.gameRounds.winLoss")) + ": ", 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(
                              __props.dataRows?.winLossAmount < 0
                                ? 'text-red-500'
                                : 'text-green-500'
                            )
                                  }, _toDisplayString(__props.dataRows?.winLossAmount), 3)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(DataTable, {
                                columns: columns,
                                data: __props.dataRows?.betResult
                              }, null, 8, ["data"])
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: "w-full text-center my-2 border rounded-md",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (showSync.value = false))
                          }, [
                            _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.$t("messages.gameRounds.close")), 1)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})